/**
 * Contacto de un cliente web sin identidad (decisión de producto: "nombre + email o teléfono").
 * Mismas reglas que booking-module (apps/services/booking-module/src/guest-contact.util.ts), que
 * vuelve a validar en servidor: si una cambia, cambia la otra.
 */

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_CHARS_RE = /^\+?[\d\s().-]+$/;

export function isValidContactEmail(value: string): boolean {
  const v = value.trim();
  return v.length > 0 && v.length <= 254 && EMAIL_RE.test(v);
}

/** Solo dígitos y separadores habituales, entre 6 y 15 dígitos. */
export function isValidContactPhone(value: string): boolean {
  const v = value.trim();
  if (!v || v.length > 50 || !PHONE_CHARS_RE.test(v)) return false;
  const digits = v.replace(/\D/g, '').length;
  return digits >= 6 && digits <= 15;
}

/** Sin identidad (ni Clerk ni canal) hay que pedir contacto en cualquier carrito, gratis o de pago. */
export function needsGuestContact(hasIdentity: boolean, itemCount: number): boolean {
  return !hasIdentity && itemCount > 0;
}

export interface GuestContactErrors {
  name?: 'required';
  email?: 'invalid';
  phone?: 'invalid';
  /** Ni email ni teléfono. */
  contact?: 'required';
}

export interface GuestContactResult {
  ok: boolean;
  errors: GuestContactErrors;
  /** Solo los campos válidos; lo vacío no se envía. */
  contact: { name: string; email?: string; phone?: string };
}

export function validateGuestContact(input: { name: string; email: string; phone: string }): GuestContactResult {
  const name = input.name.trim();
  const email = input.email.trim();
  const phone = input.phone.trim();
  const errors: GuestContactErrors = {};
  if (!name) errors.name = 'required';
  if (!email && !phone) errors.contact = 'required';
  // Un campo escrito mal se señala aunque el otro sea válido: el cliente cree que lo ha dado.
  if (email && !isValidContactEmail(email)) errors.email = 'invalid';
  if (phone && !isValidContactPhone(phone)) errors.phone = 'invalid';
  const ok = Object.keys(errors).length === 0;
  return {
    ok,
    errors,
    contact: {
      name,
      ...(email && !errors.email ? { email } : {}),
      ...(phone && !errors.phone ? { phone } : {}),
    },
  };
}
